import { useEffect, useState } from "react";
import { useToast } from "../../../../context/toast/toast-provider";
import { Evaluator } from "../../model/evaluator";
import { getEvaluatorModuleBadges, updateEvaluatorModuleBadges } from "../../service/evaluator-service";
import { Badge } from "../../model/badge";
import { EvaluatorModuleFilter } from "../model/evaluator-module-filter";
import BaseForm from "../../../../component/form/base-form";
import { evaluatorBadgeAssignFieldDefinitions } from "./evaluator-badges-assign-field-definition";
import { SelectItem } from "../../../../component/form/select-item";
import { FieldDefinition } from "../../../../component/form/field-definition";
import BaseMultiSelect from "../../../../component/mulit-select/base-multi-select";
import { getBadges } from "../../service/badge-service";

export default function EvaluatorBadgesAssign({ 
    evaluator,
    setEvaluator
}: { 
    evaluator: Evaluator,
    setEvaluator: React.Dispatch<React.SetStateAction<Evaluator>>
}) {
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [evaluatorModuleFilter, setEvaluatorModuleFilter] = useState<EvaluatorModuleFilter>({});
    const [moduleBadges, setModuleBadges] = useState<Badge[] | undefined>();
    const [selectedBadges, setSelectedBadges] = useState<Badge[]>([]);

    const toast = useToast();

    useEffect(() =>  {
        if (evaluatorModuleFilter.moduleId !== undefined) {
            setLoading(true);

            var getBadgesCall = getBadges(evaluatorModuleFilter.moduleId, true);
            var getEvaluatorModuleBadgesCall = getEvaluatorModuleBadges(evaluator.evaluatorId, evaluatorModuleFilter.moduleId);

            Promise.all([getBadgesCall, getEvaluatorModuleBadgesCall]).then(result => {
                setModuleBadges(result[0]);
                setSelectedBadges(result[1]);
                setLoading(false);
            })
        }
    }, [evaluatorModuleFilter, evaluator.evaluatorId])

    const getFieldDefinitions = (): FieldDefinition[] => {
        evaluatorBadgeAssignFieldDefinitions
            .find(_ => _.id === "moduleId")!.values = (evaluator.modules !== undefined ? evaluator.modules : [])
                .map<SelectItem>(_ => ({ id: _.moduleId, name: _.title }))
        return evaluatorBadgeAssignFieldDefinitions;
    }

    const availableBadgesText = () => {
        if (evaluatorModuleFilter.moduleId === undefined && moduleBadges === undefined) {
            return "Please select module";
        } else if (moduleBadges !== undefined && moduleBadges.length === 0) {
            return "No badge(s) for this module";
        } else {
            return "";
        }
    }

    const handleSubmit = () => {
        if (evaluatorModuleFilter.moduleId !== undefined) {
            setSubmitting(true);
            updateEvaluatorModuleBadges(evaluator.evaluatorId, evaluatorModuleFilter.moduleId, selectedBadges.map(_ => _.badgeId)).then(result => {
                if (result.length !== 0) {
                    toast.addToast(`Evaluator ${evaluator.evaluatorName} updated to cover ${result.length} badge(s)`, "success");
                } else {
                    toast.addToast(`Evaluator ${evaluator.evaluatorName} updated and all badge(s) removed`, "success");
                }
                
                var updatedEvalutade = { ...evaluator };
                updatedEvalutade!.moduleBadges![evaluatorModuleFilter.moduleId!] = result.length;
                setEvaluator(updatedEvalutade!);
                setSubmitting(false);
            }).catch(() => {
                toast.addToast(`Unable to update badge(s) for evaluator ${evaluator.evaluatorName}`, "error");
                setSubmitting(false);
            });
        }
    }

    return (
        <BaseForm
            name="Evaluator module select filter"
            model={evaluatorModuleFilter}
            setModel={setEvaluatorModuleFilter}
            fields={getFieldDefinitions()}
            submitEntity={handleSubmit}
            submitDisable={evaluatorModuleFilter.moduleId === undefined}
            submitting={submitting}
        >
            <BaseMultiSelect
                itemsloading={loading}
                items={moduleBadges}
                itemIdKey='badgeId'
                selectedItems={selectedBadges}
                setSelectedItems={setSelectedBadges}

                selectedItemsShown={false}

                availableItemsTitle='Evaluator assiged badges'
                availableItemsText={availableBadgesText()}
                availableItemRender={(badge) => <span>{badge.title}</span>}

                disabled={submitting || moduleBadges === undefined || moduleBadges.length === 0}
            />
        </BaseForm>
    );
}
